export const FETCH_ITEMS = 'SHOPPING_CART/FETCH_ITEMS';
export const FETCH_ITEMS_SUCCESS = 'SHOPPING_CART/FETCH_ITEMS_SUCCESS';
export const FETCH_ITEMS_ERROR = 'SHOPPING_CART/FETCH_ITEMS_ERROR';
export const CHANGE_QUANTITY = 'SHOPPING_CART/CHANGE_QUANTITY';
export const CHANGE_QUANTITY_SUCCESS = 'SHOPPING_CART/CHANGE_QUANTITY_SUCCESS';
export const CHANGE_QUANTITY_ERROR = 'SHOPPING_CART/CHANGE_QUANTITY_ERROR';
export const CHECKOUT = 'SHOPPING_CART/CHECKOUT';
export const CHECKOUT_SUCCESS = 'SHOPPING_CART/CHECKOUT_SUCCESS';
export const CHECKOUT_ERROR = 'SHOPPING_CART/CHECKOUT_ERROR';
export const EDIT_PRODUCT = 'SHOPPING_CART/EDIT_PRODUCT';
export const EDIT_PRODUCT_SUCCESS = 'SHOPPING_CART/EDIT_PRODUCT_SUCCESS';
export const EDIT_PRODUCT_ERROR = 'SHOPPING_CART/EDIT_PRODUCT_ERROR';
export const DELETE_ITEM = 'SHOPPING_CART/DELETE_ITEM';
export const DELETE_ITEM_SUCCESS = 'SHOPPING_CART/DELETE_ITEM_SUCCESS';
export const DELETE_ITEM_ERROR = 'SHOPPING_CART/DELETE_ITEM_ERROR';
export const CHECKOUT_ITEM = 'SHOPPING_CART/CHECKOUT_ITEM';
export const CHECKOUT_ITEM_SUCCESS = 'SHOPPING_CART/CHECKOUT_ITEM_SUCCESS';
export const CHECKOUT_ITEM_ERROR = 'SHOPPING_CART/CHECKOUT_ITEM_ERROR';
export const CHANGE_ITEM_QUANTITY = 'SHOPPING_CART/CHANGE_ITEM_QUANTITY';
export const SET_SHIPPING_TYPE = 'SHOPPING_CART/SET_SHIPPING_TYPE';
export const RESET_STATE = 'SHOPPING_CART/RESET_STATE';